import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=2f1ed744&scoped=true"
import script from "./Administration.vue?vue&type=script&lang=js"
export * from "./Administration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ed744",
  null
  
)

export default component.exports